import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import TransformScene from '../screens/Auth/TransformScene';

const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
`;

const BrandPanel = styled.div`
  flex: 1;
  background: linear-gradient(135deg, #0f172a 0%, #1a7a70 50%, #2d9a8f 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2.5rem 2rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    width: 600px;
    height: 600px;
    border-radius: 50%;
    background: rgba(78, 184, 173, 0.1);
    top: -100px;
    right: -200px;
  }

  &::after {
    content: '';
    position: absolute;
    width: 400px;
    height: 400px;
    border-radius: 50%;
    background: rgba(78, 184, 173, 0.08);
    bottom: -100px;
    left: -100px;
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

const BrandContent = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  width: 100%;
  max-width: 560px;
  max-height: 100%;
  overflow: auto;
`;

const BrandLogo = styled.div`
  width: 56px;
  height: 56px;
  margin: 0 auto 2rem;
`;

const BrandTitle = styled.h1`
  color: white;
  font-size: 2.25rem;
  margin-bottom: 0.75rem;
  font-weight: 700;
`;

const BrandSubtitle = styled.p`
  color: rgba(255, 255, 255, 0.78);
  font-size: 1rem;
  line-height: 1.6;
  margin: 0 auto;
  max-width: 28rem;
`;

const FormPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  background: var(--bg-primary);
  max-width: 540px;
  min-width: 380px;
  position: relative;

  @media (max-width: 900px) {
    max-width: 100%;
    min-width: 0;
  }

  @media (max-width: 480px) {
    padding: 1.5rem;
  }
`;

const AuthLayout: React.FC = () => {
  return (
    <Wrapper>
      <BrandPanel>
        <BrandContent>
          <BrandLogo>
            <svg viewBox="0 0 32 32" width="56" height="56" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="7" fill="rgba(255,255,255,0.15)" stroke="rgba(255,255,255,0.2)" strokeWidth="0.5" />
              <path d="M16 4Q16 16 4 16Q16 16 16 28Q16 16 28 16Q16 16 16 4Z" fill="white" />
              <circle cx="24" cy="7" r="1.8" fill="white" opacity="0.6" />
            </svg>
          </BrandLogo>
          <BrandTitle>Luminafactory</BrandTitle>
          <BrandSubtitle>
            From idea to agentic product — in minutes. Live AI in the products you
            ship, and AI your organisation can actually use.
          </BrandSubtitle>
          <TransformScene />
        </BrandContent>
      </BrandPanel>

      <FormPanel>
        <Outlet />
      </FormPanel>
    </Wrapper>
  );
};

export default AuthLayout;
